import { render, staticRenderFns } from "./cadcentroscustos.vue?vue&type=template&id=866077be&"
import script from "./cadcentroscustos.vue?vue&type=script&lang=js&"
export * from "./cadcentroscustos.vue?vue&type=script&lang=js&"
import style0 from "./cadcentroscustos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports